import { render } from "./Nfse.vue?vue&type=template&id=620a4ff6"
import script from "./Nfse.vue?vue&type=script&lang=js"
export * from "./Nfse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__